import { render } from "./Vbots.vue?vue&type=template&id=b8c638a0&scoped=true"
import script from "./Vbots.vue?vue&type=script&lang=js"
export * from "./Vbots.vue?vue&type=script&lang=js"

import "./Vbots.vue?vue&type=style&index=0&id=b8c638a0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo.ETAGEN\\Documents\\Adam-Backend\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8c638a0"]])

export default __exports__